// 深拷贝一个对象
export default function (ob) {
  return JSON.parse(JSON.stringify(ob))
}
